import { render, staticRenderFns } from "./PropertiesSearch.vue?vue&type=template&id=3f83abcc"
import script from "./PropertiesSearch.vue?vue&type=script&lang=js"
export * from "./PropertiesSearch.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSearch.vue?vue&type=style&index=0&id=3f83abcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports